import { render } from "./ListProcessDesigner.vue?vue&type=template&id=636f8f52&scoped=true"
import script from "./ListProcessDesigner.vue?vue&type=script&lang=js"
export * from "./ListProcessDesigner.vue?vue&type=script&lang=js"

import "./ListProcessDesigner.vue?vue&type=style&index=0&id=636f8f52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636f8f52"]])

export default __exports__